export const RECURRING_ZOOM_MEETING_ERROR = `This Zoom meeting is a 'No Fixed Time Recurring' meeting.
You can only edit the Connection details manually. To edit the Topic or other details, please log in to Zoom.`;